// Deep equality used to compute `dirty`/`pristine` the way redux-form did:
// null, undefined and '' are considered equal, and keys that hold an empty
// value on one side and are missing on the other side are ignored.

const isEmptyValue = value => value === null || value === undefined || value === '';

const isPlainObject = value => (
  value !== null
  && typeof value === 'object'
  && Object.getPrototypeOf(value) === Object.prototype
);

const isFormValueEqual = (left, right) => {
  if (left === right) {
    return true;
  }
  if (isEmptyValue(left) && isEmptyValue(right)) {
    return true;
  }
  if (Array.isArray(left) || Array.isArray(right)) {
    if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) {
      return false;
    }
    return left.every((item, index) => isFormValueEqual(item, right[index]));
  }
  if (isPlainObject(left) && isPlainObject(right)) {
    const keys = new Set([...Object.keys(left), ...Object.keys(right)]);
    return [...keys].every(key => isFormValueEqual(left[key], right[key]));
  }
  if (left instanceof Date && right instanceof Date) {
    return left.getTime() === right.getTime();
  }
  return false;
};

export const isEmptyFormValue = isEmptyValue;

export default isFormValueEqual;
